module.exports = __webpack_public_path__ + "img/newsheader.a75ed1b5.jpg";